export const ADD_PAYMENT_SCHEDULE = "/payments/:id/add_payment_schedule/";
export const UPDATE_PAYMENT_SCHEDULE = "/payments/:id/:paymentId/update_payment_schedule";
